function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  "data-name": "Union 2",
  d: "M915.825,27.618l-2-1.453a2,2,0,1,1,2.351-3.236l.315.229L931.336.891a2,2,0,1,1,3.328,2.219l-16,24a2,2,0,0,1-1.311.859A1.948,1.948,0,0,1,917,28,2,2,0,0,1,915.825,27.618Zm-10.239-.2-8-8a2,2,0,0,1,2.828-2.829l6.275,6.275L921.336.891a2,2,0,1,1,3.327,2.219l-16,24a2,2,0,0,1-1.467.881c-.066.006-.132.009-.2.009A2,2,0,0,1,905.585,27.414Z",
  transform: "translate(-897 0)",
  fill: "#707070"
});

var SvgDoubleCheck = function SvgDoubleCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-check.f11abd88.svg";
export { ForwardRef as ReactComponent };